<template>
  <el-container class="login_bg" type="flex" style="height:100%">
    <el-main>
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/home/index/welcome' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item v-for="(item, index) in indexPath" :key="index">{{ item.split('-')[1] }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form :inline="true" :model="formInline" size="small" class="query-form">
        <el-form-item label="软件名称">
          <el-input v-model="formInline.user_name" placeholder="请输入"></el-input>
        </el-form-item>
        <!-- <el-form-item label="交易状态">
        <el-select v-model="formInline.region" placeholder="请选择">
          <el-option label="全部" :value="0"></el-option>
          <el-option v-for="(item,index) in list" :key="index" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item label="下单时间">
          <el-date-picker v-model="formInline.dataValue" type="daterange" :picker-options="pickerOptions"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" align="right"
            @change="changeInvoiceDatePicker">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="onSearch" icon="el-icon-search">搜 索</el-button>
        </el-form-item>
      </el-form>
      <el-table border :data="tableData" style="margin-top:20px" row-key="id">
        <el-table-column prop="id" label="订单编号"></el-table-column>
        <el-table-column prop="packageName" label="软件名称"></el-table-column>
        <!-- <el-table-column prop="tips" label="规格"></el-table-column> -->
        <el-table-column prop="purchaseTime" label="购买时长"></el-table-column>
        <el-table-column prop="purchaseBy" label="下单人"></el-table-column>
        <el-table-column prop="createDt" label="下单时间"></el-table-column>
        <el-table-column prop="amount" label="付款金额"></el-table-column>
        <el-table-column prop="payRemainingDt" label="剩余付款时间"></el-table-column>
        <el-table-column prop="orderTypeName" label="交易类型"></el-table-column>
        <el-table-column prop="paymentModeName" label="交易方式"></el-table-column>
        <el-table-column prop="payTime" label="付款时间"></el-table-column>
        <el-table-column prop="orderStatusName" label="交易状态"></el-table-column>
        <el-table-column prop="invoiceStatus" label="发票状态">
          <template slot-scope="scope">
            {{ code.invoiceStatus[scope.row.invoiceStatus] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <router-link v-if="scope.row.orderStatus == 1"
              :to="{ path: '/company/pay_detailes', query: { id: scope.row.id } }" style="margin-right:10px">
              <el-button size="mini">立即付款</el-button>
            </router-link>
            <router-link :to="{ path: '/company/purchase_record_details', query: { id: scope.row.id } }"
              style="margin-right:10px">
              <el-button size="mini">订单详情</el-button>
            </router-link>
            <el-button v-if="scope.row.invoiceStatus != -1" size="mini"
              @click="getPurchaseRecordInfo(scope.$index, scope.row)">发票详情</el-button>
            <!-- <router-link :to="{ path: '/company/invoice_details',query: {id: scope.row.id}}">
            <el-button size="mini">发票详情</el-button>
          </router-link> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page="formInline.page"
        :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page>
      </el-pagination>
      <el-dialog title="发票详情" :visible.sync="dialogVisible" width="60%" center>
        <h4>状态：{{ code.invoiceStatus[invoiceInfo.invoiceStatus] }}</h4>
        <div v-if="invoiceInfo.invoiceStatus == 5" style="font-size: 14px;color: #606266;line-height: 30px;">
          拒绝理由：{{ invoiceInfo.refuseContent }}</div>
        <h4>订单信息</h4>
        <div style="font-size: 14px;color: #606266;line-height: 30px;">
          <div>订单编号：{{ orderId }}</div>
          <div>订单金额：{{ amount }}</div>
        </div>
        <h4>发票信息</h4>
        <div style="font-size: 14px;color: #606266;line-height: 30px;">
          <div>抬头名称：{{ invoiceInfo.headingName }}</div>
          <div>抬头类型：{{ code.invoiceType[invoiceInfo.headingType] }}</div>
          <div>发票类型：{{ code.invoiceType[invoiceInfo.invoiceType] }}</div>
          <div>发票性质：{{ code.invoiceNature[invoiceInfo.invoiceNature] }}</div>
          <div>纳税人识别号：{{ invoiceInfo.identificationCode }}</div>
          <div>发票内容：{{ code.invoiceContent[1] }}</div>
          <div>企业地址：{{ invoiceInfo.headingAddr }}</div>
          <div>联系电话：{{ invoiceInfo.contactTel }}</div>
          <div>开户行：{{ invoiceInfo.bankDeposit }}</div>
          <div>银行账号：{{ invoiceInfo.bankAccount }}</div>
          <div>备注：{{ invoiceInfo.remark }}</div>
        </div>
        <h4>邮寄信息</h4>
        <div style="font-size: 14px;color: #606266;line-height: 30px;">
          <div v-if="invoiceInfo.invoiceNature == 2">
            <div>收货人：{{ invoiceInfo.mailContactUser }}</div>
            <div>联系电话：{{ invoiceInfo.mailContactTel }}</div>
            <div>收货地址：{{ invoiceInfo.mailAddr }}</div>
            <div>邮编：{{ invoiceInfo.postalCode }}</div>
          </div>
          <div v-if="invoiceInfo.invoiceNature == 1">邮箱：{{ invoiceInfo.email }}</div>
        </div>
      </el-dialog>
    </el-main>

    <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </el-container>
</template>
<script>
import {
  getPurchaseRecordList,
  getPurchaseRecordInfo,
  // submit
} from '@/api.js'
import {
  mapState
} from 'vuex'

export default {
  name: "SystemRole",
  data() {
    return {
      tableData: [],
      formInline: {
        pid: 0,
        packageName: '',
        dataValue: [],
        createEndDt: '',
        createStartDt: '',
        page: 1,
        size: 10
      },
      total: 0,
      invoiceInfo: {},
      orderId: '',
      amount: '',
      dialogVisible: false,
    }
  },
  mounted() {
    var moment = require('moment');
    this.formInline.start_dt = moment().subtract(30, 'days').format('YYYY-MM-DD')
    this.formInline.end_date = moment().format('YYYY-MM-DD')
    this.formInline.dataValue = [this.formInline.start_dt, this.formInline.end_date]
    this.getTableDate();
  },
  methods: {
    //获取表格数据
    getTableDate() {
      getPurchaseRecordList(this.formInline).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //表格查询
    onSearch() {
      this.formInline.page = 1
      this.getTableDate();
    },
    handleCurrentChange(val) {
      this.formInline.page = val
      this.getTableDate();
    },
    handleSizeChange(val) {
      this.formInline.page = 1
      this.formInline.pageSize = val
      this.getTableDate();
    },
    getPurchaseRecordInfo(index, row) {
      getPurchaseRecordInfo({
        cid: row.cid,
        orderId: row.id
      }).then(res => {
        if (res.code == 0) {
          this.dialogVisible = true
          this.orderId = row.id
          this.amount = row.amount
          this.invoiceInfo = res.data.invoiceInfo
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  computed: {
    ...mapState({
      indexPath: state => state.indexPath,
      code: state => state.code,
    }),
  },
}
</script>

<style scoped lang="scss">
.el-container {
  flex-direction: column;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }
}
</style>